import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { IconTypography } from 'src/components/iconTypography/IconTypography';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { useGetProjectConfig } from 'src/hooks';
import { useGetHealthCheck } from 'src/hooks/api/healthCheck/useGetHealthCheck';
import { lang, theme, useUserRole } from 'src/utils';
import { isProduction } from 'src/utils/environment';

import { version as CC_UI_VERSION } from '../../../../package.json';
import {
  CardWrapper,
  PageHeading,
  SubHeading,
  VersionCard,
} from './AboutPage.styled';

export const AboutPage = () => {
  const { data: projectConfig } = useGetProjectConfig();
  const { data: ccBackendVersion } = useGetHealthCheck();

  const renderNotFound = (
    <IconTypography
      icon={<WarningIcon />}
      text={lang.notFoundText}
      textFontSize="16px"
      textFontWeight="400"
      textColor={theme.status.danger.dark}
      iconColor={theme.palette.brand.yellow}
    />
  );

  const ccVersionData = {
    [lang.ccUI]: isProduction() ? CC_UI_VERSION : lang.localVersion,
    [lang.ccBE]: ccBackendVersion?.version,
  };

  const gcfVersionData = {
    [lang.gcfPlayer]: projectConfig?.gcf?.apps.player.version,
    [lang.gcfCOD]: projectConfig?.gcf?.apps.cod.version,
    [lang.gcfComponents]: projectConfig?.gcf?.apps.components.version,
  };

  const { isViewOnly } = useUserRole();

  return (
    <Grid>
      <Box sx={{ position: 'absolute', top: 0, right: 0, margin: 4 }}>
        {isViewOnly && <ViewOnlyAlert />}
      </Box>
      <PageHeading variant="h1">{lang.about}</PageHeading>
      <SubHeading variant="h5">{lang.creativeCenterVersionSubText}</SubHeading>
      <CardWrapper>
        {Object.entries(ccVersionData).map(([key, value]) => (
          <VersionCard key={key}>
            <Typography>{key}</Typography>
            {value ? (
              <Typography data-testid="cc-versions">{value}</Typography>
            ) : (
              renderNotFound
            )}
          </VersionCard>
        ))}
      </CardWrapper>

      <SubHeading variant="h5">{lang.gcfVersionSubText}</SubHeading>
      <CardWrapper>
        {Object.entries(gcfVersionData).map(([key, value]) => (
          <VersionCard key={key}>
            <Typography>{key}</Typography>
            {value ? <Typography>{value}</Typography> : renderNotFound}
          </VersionCard>
        ))}
      </CardWrapper>
    </Grid>
  );
};
